import * as u from "react";
import { jsx as P } from "react/jsx-runtime";
function _(e, t) {
  const n = u.createContext(t), s = (c) => {
    const { children: r, ...f } = c, i = u.useMemo(() => f, Object.values(f));
    return /* @__PURE__ */ P(n.Provider, { value: i, children: r });
  };
  s.displayName = e + "Provider";
  function o(c) {
    const r = u.useContext(n);
    if (r) return r;
    if (t !== void 0) return t;
    throw new Error(`\`${c}\` must be used within \`${e}\``);
  }
  return [s, o];
}
function y(e, t = []) {
  let n = [];
  function s(c, r) {
    const f = u.createContext(r), i = n.length;
    n = [...n, r];
    const a = (d) => {
      var S;
      const { scope: l, children: h, ...x } = d, m = ((S = l == null ? void 0 : l[e]) == null ? void 0 : S[i]) || f, b = u.useMemo(() => x, Object.values(x));
      return /* @__PURE__ */ P(m.Provider, { value: b, children: h });
    };
    a.displayName = c + "Provider";
    function C(d, l) {
      var m;
      const h = ((m = l == null ? void 0 : l[e]) == null ? void 0 : m[i]) || f, x = u.useContext(h);
      if (x) return x;
      if (r !== void 0) return r;
      throw new Error(`\`${d}\` must be used within \`${c}\``);
    }
    return [a, C];
  }
  const o = () => {
    const c = n.map((r) => u.createContext(r));
    return function(f) {
      const i = (f == null ? void 0 : f[e]) || c;
      return u.useMemo(
        () => ({ [`__scope${e}`]: { ...f, [e]: i } }),
        [f, i]
      );
    };
  };
  return o.scopeName = e, [s, v(o, ...t)];
}
function v(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const s = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(c) {
      const r = s.reduce((f, { useScope: i, scopeName: a }) => {
        const d = i(c)[`__scope${a}`];
        return { ...f, ...d };
      }, {});
      return u.useMemo(() => ({ [`__scope${t.scopeName}`]: r }), [r]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function p(e) {
  const t = u.useRef(e);
  return u.useEffect(() => {
    t.current = e;
  }), u.useMemo(() => (...n) => {
    var s;
    return (s = t.current) == null ? void 0 : s.call(t, ...n);
  }, []);
}
var M = globalThis != null && globalThis.document ? u.useLayoutEffect : () => {
};
function R(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function j({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [s, o] = $({ defaultProp: t, onChange: n }), c = e !== void 0, r = c ? e : s, f = p(n), i = u.useCallback(
    (a) => {
      if (c) {
        const d = typeof a == "function" ? a(e) : a;
        d !== e && f(d);
      } else
        o(a);
    },
    [c, e, o, f]
  );
  return [r, i];
}
function $({
  defaultProp: e,
  onChange: t
}) {
  const n = u.useState(e), [s] = n, o = u.useRef(s), c = p(t);
  return u.useEffect(() => {
    o.current !== s && (c(s), o.current = s);
  }, [s, o, c]), n;
}
export {
  j as a,
  R as b,
  y as c,
  p as d,
  _ as e,
  M as u
};
